export default [
  'date',
  'ipv4ClassB',
  'ipv4ClassA',
  'ipv4ClassC',
  'ipv4',
  'ipRangeId',
  'creativeId',
  'trafficBlacklistId',
  'trafficType',
  'subId',
  'buyerCampaignOrig',
  'buyerCampaignId',
  'buyerSiteOrig',
  'buyerSiteId',
  'uuid',
  'userAgent',
  'ipRange',
  'bannerDimenssions'
];
